export const MESSAGE_SUCCESS_CATEGORIE = `La catégorie est bien créée`;
export const MESSAGE_SUCCESS_CATEGORIE_MAPPING = `Le mapping est bien créée`;
export const MESSAGE_DELETE_CATEGORIE_MAPPING = `Le mapping est bien suprimé`;
export const MESSAGE_SUCCESS_CATEGORY_EDIT = `La catégorie a bien été modifiée`;
export const LOGIN_SUCCESS = `Bienvenue sur le module de mapping`;
export const MESSAGE_SUCCESS_ATTRIBUTE = `L'attribut a été correctement ajouté`;
export const MESSAGE_SUCCESS_EDIT_ATTRIBUTE = `L'attribut a été correctement modifié`;
export const MESSAGE_SUCCESS_IMPORT = `Fichier importé avec succès`;
export const MESSAGE_SUCCESS_DELETE_ATTRIBUTE = `L'attribut a bien été supprimé`;
